/*eslint-disable*/
import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useHistory } from "react-router-dom";
// import axios from "axios";

import classNames from "classnames";
import Parallax from "components/Parallax/Parallax.js";
import { makeStyles } from "@material-ui/core/styles";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import VisibilityIcon from "@material-ui/icons/Visibility";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import CreditCardIcon from "@material-ui/icons/CreditCard";
import Button from "components/CustomButtons/Button.js";
import { localApi, credentials } from "utils/headApi";
// import Slide from "@material-ui/core/Slide";
// import Tooltip from "@material-ui/core/Tooltip";
// import Close from "@material-ui/icons/Close";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
// import Table from "components/Table/Tables.js";
import Tables from "components/Table/Table.js";
import CustomLinearProgress from "components/CustomLinearProgress/CustomLinearProgress.js";
import profilePageStyle from "assets/jss/material-kit-pro-react/views/profilePageStyle.js";
import InshaHeader from "views/InshaBanglesPage/Section/InshaHeader";
import InshaHeaderLink from "views/InshaBanglesPage/Section/InshaHeaderLink";
import Footer from "views/InshaBanglesPage/Section/InshaFooter";

import invoiceStyle from "assets/jss/material-kit-pro-react/views/invoiceTableStyle";
import listCart from "assets/jss/material-kit-pro-react/views/shoppingCartStyle.js";
import aboutUsStyle from "assets/jss/material-kit-pro-react/views/blogPostsPageStyle.js";

const useStyles = makeStyles(profilePageStyle);
const useStylesTable = makeStyles(invoiceStyle);
const useStyleCart = makeStyles(listCart);
const useStyl = makeStyles(aboutUsStyle);

export default function OrdersList({ ...rest }) {
  const [ordersList, setOrdersList] = React.useState([]);
  // const [userId, setUserId] = React.useState("");
  const [load, setLoad] = React.useState(false);

  const [expandedRows, setExpandedRows] = React.useState([]);
  const [expandState, setExpandState] = React.useState({});

  const classes = useStyles();
  const history = useHistory();

  // const classesTable = useStylesTable();
  // const classeCart = useStyleCart();
  const classeTitel = useStyl();

  const activeSession = sessionStorage.getItem("sessionData");
  const userObj = JSON.parse(sessionStorage.getItem("sessionData"));

  const date = Intl.DateTimeFormat("fr-CA", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  })
    .format(new Date())
    .replaceAll("/", "-");

  const current = new Date();
  const dateCurrent = `${current.getDate()}-${
    current.getMonth() + 1
  }-${current.getFullYear()}`;
  current.setDate(current.getDate() + 10);
  let dateEx = new Date(current).toLocaleDateString("de");

  async function getList() {
    const response = await fetch(localApi + `/clientGroup/allList`, {
      method: "GET",
      headers: {
        Authorization: `Basic ${credentials}`,
      },
    });
    const json = await response.json();
    const regClient = json.ClientList.filter((f) => f.regId == userObj.id)[0];
    // console.log(regClient);

    const getList = await fetch(
      localApi +
        `/orders/list/byAdminAndCliId/${userObj.admin.id}/${regClient.id}`,
      {
        method: "GET",
        headers: {
          Authorization: `Basic ${credentials}`,
        },
      },
    );
    const res = await getList.json();
    const getResult = res.filter((f) => f.cancelOrders != true);
    // console.log(res);
    // setLoad(true);
    // setOrdersList(res);

    if (getResult.length === 0) {
      setLoad(false);
      history.push("/");
    } else {
      setLoad(true);
      setOrdersList(getResult);
    }
  }

  useEffect(() => {
    getList();
  }, []);

  // const handleExpandRow = (uId) => {
  //     const isExpanded = expandedRows.includes(uId);

  //     let obj = {};
  //     obj[uId] = !isExpanded;
  //     setExpandState(obj);

  //     const newExpandedRows = isExpanded
  //         ? expandedRows.filter((id) => id !== uId)
  //         : [...expandedRows, uId];

  //     setExpandedRows(newExpandedRows);
  // };

  const handleExpandRow = (uId) => {
    const isExpanded = expandedRows.includes(uId);

    // Update expandState without wiping old values
    setExpandState((prev) => ({
      ...prev,
      [uId]: !isExpanded,
    }));

    // Update expandedRows
    const newExpandedRows = isExpanded
      ? expandedRows.filter((id) => id !== uId)
      : [...expandedRows, uId];

    setExpandedRows(newExpandedRows);
  };

  return (
    <div>
      <Helmet>
        <title>Orders List</title>
      </Helmet>
      {load ? (
        <>
          <InshaHeader
            brand="Home"
            links={<InshaHeaderLink dropdownHoverColor="dark" />}
            fixed
            color="dark"
            // color="transparent"
            // changeColorOnScroll={{
            //     height: 100,
            //     color: "dark",
            // }}
          />
          <Parallax
            image={require("assets/img/Order-List.jpg").default}
            // filter="dark"
            className={classes.parallax}
          >
            <div className={classeTitel.container}>
              <GridContainer>
                <GridItem
                  md={8}
                  sm={8}
                  className={classNames(
                    classeTitel.mlAuto,
                    classeTitel.mrAuto,
                    // classeTitel.textCenter,
                  )}
                >
                  <h1 className={classeTitel.title} style={{ color: "black" }}>Orders Lists</h1>
                  <h4></h4>
                </GridItem>
              </GridContainer>
            </div>
          </Parallax>

          <div
            className={classes.container}
            // style={{ marginTop: "2%" }}
          >
            <GridContainer>
              {ordersList &&
                ordersList.map((c, index) => (
                  <GridItem xs={12} sm={4} md={4} key={index}>
                    <Card>
                      <CardBody>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0px",
                          }}
                        >
                          {c.adminCompany != null ? (
                            <span style={{ fontWeight: "bold" }}>
                              {c.adminCompany}
                            </span>
                          ) : (
                            ""
                          )}

                          {c.adminCity != null && c.adminState != null ? (
                            <span>{c.adminCity + ", " + c.adminState}</span>
                          ) : (
                            ""
                          )}

                          <span style={{ fontWeight: "bold" }}>
                            {c.transbranch.company}
                          </span>

                          <span>
                            {c.transbranch.city + ", " + c.transbranch.state}
                          </span>

                          <div style={{ display: "flex" }}>
                            <span style={{ width: "40%" }}>SR/Order No.:</span>
                            <span style={{ width: "60%", fontWeight: "bold" }}>
                              {index + 1} / {c.id}
                            </span>
                          </div>

                          <div style={{ display: "flex" }}>
                            <span style={{ width: "40%" }}>Date:</span>
                            <span style={{ width: "60%", fontWeight: "bold" }}>
                              {c.createDate.slice(0, 10)}
                            </span>
                          </div>

                          <div style={{ display: "flex" }}>
                            <span style={{ width: "40%" }}>Units:</span>
                            <span style={{ width: "60%", fontWeight: "bold" }}>
                              {c.totalBox} - Units
                            </span>
                          </div>

                          <div style={{ display: "flex" }}>
                            <span style={{ width: "40%" }}>Cartoon:</span>
                            <span style={{ width: "60%", fontWeight: "bold" }}>
                              {c.totalCarton}
                            </span>
                          </div>

                          <div style={{ display: "flex" }}>
                            <span style={{ width: "40%" }}>Bill Amount:</span>
                            <span style={{ width: "60%", fontWeight: "bold" }}>
                              ₹ {Math.round(c.amount)}/-
                            </span>
                          </div>

                          <div style={{ display: "flex" }}>
                            <span style={{ width: "40%" }}>
                              Balance Amount:
                            </span>
                            <span style={{ width: "60%", fontWeight: "bold" }}>
                              ₹ {Math.round(c.balance)}/-
                            </span>
                          </div>

                          {/* ACTION BAR */}
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              marginTop: 5,
                            }}
                            onClick={() => handleExpandRow(c.id)}
                          >
                            <span style={{ width: "40%", fontWeight: "bold" }}>
                              Actions:
                            </span>

                            {Math.round(c.balance) === 0 ? (
                              <>
                                <span
                                  style={{
                                    marginLeft: 4,
                                    marginRight: 10,
                                    fontWeight: "bold",
                                    color: "green",
                                  }}
                                >
                                  Paid
                                </span>
                                {expandedRows.includes(c.id) ? (
                                  <ArrowUpwardIcon style={{ color: "green" }} />
                                ) : (
                                  <ArrowDownwardIcon
                                    style={{ color: "green" }}
                                  />
                                )}
                              </>
                            ) : (
                              <>
                                <span
                                  style={{
                                    marginLeft: 4,
                                    marginRight: 10,
                                    fontWeight: "bold",
                                    color: "red",
                                  }}
                                >
                                  Payment History
                                </span>
                                {expandedRows.includes(c.id) ? (
                                  <ArrowUpwardIcon style={{ color: "red" }} />
                                ) : (
                                  <ArrowDownwardIcon style={{ color: "red" }} />
                                )}
                              </>
                            )}
                          </div>

                          {/* EXPANDED PAYMENT DETAILS */}
                          {expandedRows.includes(c.id) && (
                            <div
                              style={{
                                marginTop: 10,
                                padding: 10,
                                borderRadius: 6,
                              }}
                            >
                              <div
                                style={{ display: "flex", fontWeight: "bold" }}
                              >
                                <span style={{ width: "20%" }}>SR</span>
                                <span style={{ width: "40%" }}>Date</span>
                                <span
                                  style={{ width: "40%", textAlign: "right" }}
                                >
                                  Amount
                                </span>
                              </div>

                              {c.payment.map((op, idx) => (
                                <div
                                  key={op.id}
                                  style={{
                                    display: "flex",
                                    color: "black",
                                    padding: "4px 0",
                                  }}
                                >
                                  <span style={{ width: "20%" }}>
                                    {idx + 1}
                                  </span>
                                  <span style={{ width: "40%" }}>
                                    {op.createDate.slice(0, 10)}
                                  </span>
                                  <span
                                    style={{ width: "40%", textAlign: "right" }}
                                  >
                                    ₹ {op.received}
                                  </span>
                                </div>
                              ))}

                              <div
                                style={{
                                  display: "flex",
                                  fontWeight: "bold",
                                  marginTop: 8,
                                }}
                              >
                                <span style={{ width: "20%" }}>
                                  {c.payment.length}
                                </span>
                                <span style={{ width: "40%" }}>
                                  Grand Total
                                </span>
                                <span
                                  style={{ width: "40%", textAlign: "right" }}
                                >
                                  ₹{" "}
                                  {Math.round(
                                    c.payment.reduce(
                                      (a, b) => a + b.received,
                                      0,
                                    ),
                                  )}
                                </span>
                              </div>
                            </div>
                          )}
                        </div>
                      </CardBody>
                    </Card>
                  </GridItem>
                ))}
            </GridContainer>
          </div>

          <Footer />
        </>
      ) : (
        ""
      )}
    </div>
  );
}
